import BookingView from './Booking';

export default BookingView;
